import { css } from "@emotion/react";
import { useIsSpMode } from "@/hooks";

export const TermsOfIDPackageContent = () => {
  const isSpMode = useIsSpMode();
  return (
    <>
      <div css={container}>
        <div css={!isSpMode ? box : spModeBox}>
          <div css={content}>
            「Mikatano
            ID」利用規約（以下「本規約」といいます。）は、マネーフォワードエックス株式会社（以下「当社」といいます。）がMikatano
            IDサービス（第2条第1号で定義するものをいいます。）及び指定サービス（第2条第8号で定義するものをいいます。）を利用することに関して、利用者（第2条第5号に定義するものをいいます。）及び利用希望者（第2条第6号に定義するものをいいます。）に同意していただく必要のある事項を記載しています。Mikatano
            IDサービスをご利用になる際には、本規約が適用されます。なお、本規約については、利用希望者が利用登録した時点で同意されたものとさせていただきますので、ご利用の前に必ずお読みください。
          </div>
          <p>
            <h4 css={articleTitle}>第1条（規約の適用）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  本規約は、Mikatano
                  IDサービス及び指定サービスの利用に対して適用されます。また、指定サービスの利用に対して指定サービス利用規約（第2条第9号に定義するものをいいます。）も適用され、指定サービス利用規約が本規約と抵触する場合には、指定サービス利用規約が優先されるものとします。
                </li>
                <li>
                  当社が、
                  <a href="/terms/service" target="_blank" css={a}>
                    指定サービスに関する特約
                  </a>
                  及び
                  <a
                    href="/terms/policy_data_provision"
                    target="_blank"
                    css={a}
                  >
                    利用者情報の第三者提供に関する特約
                  </a>
                  その他のMikatano
                  IDサービス又は指定サービスに関する個別規定及び追加規定（以下「個別規定等」といいます。）の効力発生の相当期間前までに、当該個別規定等の内容及びその効力発生時期を当社の運営するウェブサイト又はアプリ（以下「当社ウェブサイト等」といいます。）上に掲載する場合、個別規定等もMikatano
                  IDサービス及び指定サービスの利用に対して適用され、個別規定等が本規約又は指定サービス利用規約と抵触する場合には、当該個別規定等が優先されるものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第2条（定義）</h4>
            <p css={p}>
              本規約において、次の各号に掲げる用語は、当該各号に定めるとおり定義します。
            </p>
            <ol css={ol}>
              <li>
                「Mikatano IDサービス」
                <br />
                当社が本規約に基づき提供する、法人、団体又は個人事業主が、ユーザーアカウントを指定サービスの認証に使用することができるサービスをいいます。
              </li>
              <li>
                「サービス利用契約」
                <br />
                当社と利用者との間の Mikatano IDサービス及び契約プラン（本条第
                11
                号に定義するものをいいます。）に含まれる指定サービス（併せて、以下「Mikatano
                IDサービス等」といいます。）の利用に関する契約をいいます。なお、サービス利用契約は、本規約、指定サービス利用規約、個別規定等のほか、当社ウェブサイト等上に掲載されるMikatano
                IDサービス等の利用に関連するルール及び通知等をその内容に含みます。
              </li>
              <li>
                「契約者」
                <br />
                本規約に同意の上、当社とサービス利用契約を締結した法人、団体又は個人事業主をいいます。
              </li>
              <li>
                「ユーザー」
                <br />
                契約者がMikatano
                IDサービスの利用を認め、当社所定の方法により、Mikatano
                IDサービスを利用することが可能となった者をいいます。
              </li>
              <li>
                「利用者」
                <br />
                契約者及びユーザーをいいます。
              </li>
              <li>
                「利用希望者」
                <br />
                当社とサービス利用契約を締結することを希望する法人、団体又は個人事業主をいいます。
              </li>
              <li>
                「登録情報」
                <br />
                利用者及び利用希望者がMikatano
                IDサービス等に登録した当社が定める情報、Mikatano
                IDサービス等の利用中に当社が必要と判断して登録を求めた情報並びにこれらの情報について利用者自身が追加又は変更した場合の当該情報をいいます。
              </li>
              <li>
                「指定サービス」
                <br />
                当社が提供する各種サービスのうち、当社ウェブサイト等で定めるサービスをいいます。
              </li>
              <li>
                「指定サービス利用規約」
                <br />
                指定サービスの利用に対して適用される各利用規約をいいます。
              </li>
              <li>
                「プラン」
                <br />
                当社が定める1つまたは2つ以上の指定サービスを組み合わせたものをいいます。
              </li>
              <li>
                「契約プラン」
                <br />
                利用者がその利用を選択したプランをいいます。
              </li>
              <li>
                「Mikatano ID」
                <br />
                ユーザーパスワードと組み合わせて、利用者とその他の者とを識別するために用いられる符号をいいます。
              </li>
              <li>
                「ユーザーパスワード」
                <br />
                Mikatano
                IDと組み合わせて、利用者とその他の者とを識別するために用いられる符号をいいます。
              </li>
              <li>
                「ユーザーアカウント」
                <br />
                Mikatano ID及びユーザーパスワードを総称したものをいいます。
              </li>
              <li>
                「パートナーサービス」
                <br />
                第三者が運営するサービスのうち、アカウント連携（本条第19号に定義するものをいいます。）が可能として当社が任意に指定するサービスをいいます。
              </li>
              <li>
                「パートナーサービスID」
                <br />
                パートナーサービスパスワード（本条第17号に定義するものをいいます。）と組み合わせて、利用者を識別するために用いられる符号をいいます。
              </li>
              <li>
                「パートナーサービスパスワード」
                <br />
                パートナーサービスIDと組み合わせて、利用者を識別するために用いられる符号をいいます。
              </li>
              <li>
                「パートナーサービスアカウント」
                <br />
                パートナーサービスID及びパートナーサービスパスワードを総称したものをいいます。
              </li>
              <li>
                「アカウント連携」
                <br />
                利用者が、パートナーサービスアカウントにて指定サービスを利用することを可能とすることをいいます。
              </li>
              <li>
                「送信データ」
                <br />
                利用者が指定サービスを利用して送信又は保存するコンテンツ（文字、数字、数式、画像その他のデータを含みますがこれらに限りません。以下、本規約において同じです。）をいいます。
              </li>
              <li>
                「アグリゲーションサービス」
                <br />
                利用者の指示・同意に基づき、当社又は株式会社マネーフォワードが各コンテンツサイト又はAPI提供元のシステムにアクセスし、もって利用者の口座情報を取得し、取得した口座情報を当社ウェブサイト等又は利用者の指定する第三者が提供するサービス上に反映・表示すること（当座口座情報を加工した情報を表示することを含みます。）ができるサービスをいいます。
              </li>
              <li>
                「口座情報」
                <br />
                指定サービスにおいて当社が取得する利用者の普通預金、定期預金、クレジットカード、電子マネー、株式、投資信託、ポイントその他の残高・取引等の情報をいいます。
              </li>
              <li>
                「コンテンツサイト」
                <br />
                第三者が運営する、口座情報を提供するサービスを行うサイトのうち、当社が任意に指定するサイトをいいます。
              </li>
              <li>
                「API提供元」
                <br />
                APIトークン（利用者からの申請又は要請のもと、第三者が当社又は株式マネーフォワードに対して、当社が当該利用者の口座情報を取得するために発行するトークンをいいます。）を発行する者をいいます。
              </li>
              <li>
                「提携サービス」
                <br />
                第三者が運営するサービスのうち、指定サービスにおいて利用が可能として当社が任意に指定するサービスをいいます。
              </li>
              <li>
                「知的財産権」
                <br />
                著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）をいいます。
              </li>
              <li>
                「反社会的勢力等」
                <br />
                暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、右翼団体、暴力団準構成員、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団その他これに準ずる者をいいます。
              </li>
            </ol>
            <h4 css={articleTitle}>第3条（利用者の登録）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用希望者は、本規約を遵守することに同意し、かつ登録情報を当社の定める方法で当社に提供することにより、当社に対し、Mikatano
                  IDサービスの利用の登録（以下「利用登録」といいます。）を申請することができるものとします。
                </li>
                <li css={li}>
                  当社は、当社の基準に従って、利用登録の可否を判断し、当社が登録を認めた利用希望者に限り、利用登録を完了し、Mikatano
                  IDサービスを提供するものとします。
                </li>
                <li css={li}>
                  サービス利用契約は、当社が利用希望者に対して、Mikatano
                  IDサービス等を利用するためのユーザーアカウントを発行した時、パートナーアカウントとのアカウント連携を完了した時、又は当社が利用を認めた時に、契約者と当社の間に成立し、これ以降、契約者はMikatano
                  IDサービス等を当社の定める方法で利用することができるようになります。
                </li>
                <li css={li}>
                  未成年者がMikatano
                  IDサービス等の利用を希望する場合には、法定代理人の同意が必要になります。なお、契約者が利用登録の申請を行った時点で未成年者であった場合、成年に達した後にMikatano
                  IDサービス等を利用したときは、未成年者であった間の利用行為を追認したものとみなします。
                </li>
                <li css={li}>
                  利用者は、登録情報の登録にあたっては、真実かつ正確な情報を送信しなければなりません。当社は、利用者自身が登録した登録情報を前提として、Mikatano
                  IDサービス等を提供いたします。登録情報の内容に虚偽、誤り又は記載漏れがあったことにより利用者に生じた損害について、当社は一切責任を負いません。次条により登録情報の変更が生じた場合も同様とし、当社は利用者によるMikatano
                  IDサービス等の利用時点における登録情報を前提として、Mikatano
                  IDサービス等を提供いたします。
                </li>
                <li css={li}>
                  当社は、Mikatano
                  IDサービス等の適切な運用のため、登録情報及び利用者によるMikatano
                  IDサービス等の利用状況等を確認することがあるものとし、利用者はこれに予め同意するものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第4条（登録情報の変更）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者は、登録情報に変更があった場合、速やかに、当社所定の変更手続を行うものとします。
                </li>
                <li css={li}>
                  利用者は、前項の変更を怠ったことにより当社からの通知が不到達となった場合、当該通知は通常到達すべき時に到達したとみなされることを予め異議無く承諾するものとします。
                </li>
                <li css={li}>
                  利用者が登録情報の変更を怠ったことにより生じた損害について、当社は一切責任を負わないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第5条（ユーザーアカウントの管理）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者は、自己の責任において、当社から発行されたユーザーアカウントを管理及び保管するものとし、これを第三者に利用させ、貸与・譲渡・名義変更・売買等をしてはならないものとします。当社は、当該ユーザーアカウントの一致を確認した場合、当該ユーザーアカウントを保有するものとして登録された利用者がMikatano
                  IDサービスを利用したものとみなします。
                </li>
                <li css={li}>
                  ユーザーアカウントの管理不十分、使用上の過誤、及び第三者の使用等による損害の責任は、当社に故意又は重過失があった時を除き、利用者が負うものとし、当社はその責任を負いません。
                </li>
                <li css={li}>
                  利用者は、Mikatano
                  ID、ユーザーパスワード、パートナーサービスID又はパートナーサービスパスワードが盗まれたり、第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第6条（プラン）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  契約者は、サービス利用契約の内容として、１つのプランを選択するものとします。プランの詳細は当社ウェブサイト等をご確認ください。
                </li>
                <li css={li}>
                  契約者は、プランに含まれる指定サービスに関する指定サービス利用規約及び個別規定等（以下「指定サービス利用規約等」といいます。）に同意の上、当社所定の手続に従って、プラン選択の手続を行うものとします。
                </li>
                <li css={li}>
                  契約者は、利用する指定サービスを追加又は変更する場合、当社が指定する方法により契約プランの変更を申し込むものとします。当社がこの申込みを承諾した日に契約プランの変更の効力が発生するものとします。但し、変更後の契約プランの利用料金は、契約プランの変更の効力の発生日の属する月の翌月から適用します。
                </li>
                <li css={li}>
                  利用者は、契約プランの変更により指定サービスを追加した場合、契約プランの変更の効力の発生日から当該指定サービスを利用することができるものとします。また、利用者は、契約プランの変更の効力の発生日の属する月の翌月以降、変更後の契約プランに含まれない指定サービスを利用することができず、当該指定サービスに含まれる情報を編集又は閲覧できなくなることがあることを、予め承諾するものとします。
                </li>
                <li css={li}>
                  当社は、プランの種類又は内容等を追加、変更または終了（以下「変更等」といいます。）する場合があります。この場合において、当社は、契約者に対して、当社ウェブサイト等への掲載その他当社が適当と判断する方法により、変更等の内容、変更等に伴う措置等を当該変更等の相当期間前までに通知します。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第7条（サービスの利用）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者は、サービス利用契約の有効期間内において、日本国内での利用に限り、当社がMikatano
                  IDサービス等を提供する目的の範囲内でかつ本規約及び指定サービス利用規約等に違反しない範囲内で、当社の定める方法に従い、Mikatano
                  IDサービス等を利用することができるものとします。
                </li>
                <li css={li}>
                  利用者は、その費用と責任において、Mikatano
                  IDサービス等の提供を受けるために必要なコンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持するものとします。
                </li>
                <li css={li}>
                  利用者は、Mikatano IDサービス等の利用開始に際し又はMikatano
                  IDサービス等の利用中に、当社ウェブサイト等からのダウンロードその他の方法によりソフトウェア等を利用者のコンピューター等にインストールする場合、利用者が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとし、当社は、かかる事象に基づき利用者に生じた損害について、当社に故意又は重過失があった時を除き、その責任を負わないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第8条（ユーザー）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  契約者は、当社の定める条件及び方法に従い、契約者の役員、従業員、契約者の業務に従事する者、その他の契約者がユーザーとして適当であると判断した者をユーザーとして招待すること、及び当該ユーザーをMikatano
                  IDサービス又は指定サービスの利用者から除外することができるものとします。ただし、当社は、契約者が招待した当該ユーザーがMikatano
                  IDサービス又は指定サービスの利用者として適当でないと判断した場合には、当該ユーザーの利用を停止し、または退会させることができるものとします。
                </li>
                <li css={li}>
                  前項の規定に基づき招待されたユーザーは、当該契約者のデータ等の作成、編集及び閲覧その他当社が定める権限の全部又は一部を行使することができるものとします。
                </li>
                <li css={li}>
                  契約者は、第1項の規定に基づき招待したユーザーに本規約、指定サービス利用規約等に同意させることを保証し、かつ、Mikatano
                  IDサービス等を本規約及び指定サービス利用規約等を遵守して利用するよう管理及び監督する責任を負うものとします。ユーザーによる行為は契約者による行為とみなして本規約及び指定サービス利用規約等を適用し、ユーザーが本規約又は指定サービス利用規約等の内容に違反した場合には、契約者が違反したものとみなし、当社に対して一切の責任を負うものとします。ユーザーが本規約又は指定サービス利用規約等の内容のいずれかに違反した場合、当社は、当該ユーザーに対し、契約者を通じることなく、本規約及び指定サービス利用規約等に定める措置を行使することができるものとします。
                </li>
                <li css={li}>
                  当社は、契約者又はユーザーが本規約又は指定サービス利用規約等の内容のいずれかに違反したことに起因して、第三者に損害が生じた場合又は第三者と紛争が生じた場合、当社に故意又は重過失があった時を除き、何らの責任を負うことなく、契約者が自らの責任と費用負担により解決するものとします。当該紛争によって当社が損害（弁護士費用を含みますが、これに限りません。）を被った場合、契約者は当社が被った一切の損害を賠償するものとします。
                </li>
                <li css={li}>
                  前二項の定めは、本規約又は指定サービス利用規約の内容に違反したユーザーを免責するものではなく、当社の当該ユーザーに対する損害賠償の請求を妨げません。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>
              第9条（パートナーサービスアカウントとユーザーアカウントの連携）
            </h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  契約者は、パートナーサービスと契約関係にある場合（当該契約者を、以下「パートナーサービス利用契約者」といいます。）、パートナーサービスアカウントをMikatano
                  IDサービス等の認証に使用の上、Mikatano
                  IDサービス等を利用するものとします。パートナーサービス契約者は、Mikatano
                  IDサービスの利用登録の申請時に次項に基づきアカウント連携を行うものとし、Mikatano
                  IDを取得してアカウント連携することなくMikatano
                  IDサービス等を利用することはできません。なお、パートナーサービス利用契約者が招待したユーザーは、ユーザーアカウントを利用して指定サービスを利用することができます。
                </li>
                <li css={li}>
                  パートナーサービス利用契約者は、Mikatano
                  IDサービスの利用登録の申請時にパートナーサービスアカウントを用いた認証機能によりパートナーサービスにログインするものとします。当該ログインの完了をもってアカウント連携が完了し、パートナーサービス利用契約者は、パートナーサービスアカウントをMikatano
                  IDサービス等の認証に使用することができます。
                </li>
                <li css={li}>
                  パートナーサービス利用契約者は、サービス利用契約期間中アカウント連携を解除することができないものとします。
                </li>
                <li css={li}>
                  パートナーサービス利用契約者は、パートナーサービスアカウントの登録及び利用等に関し、当該パートナーサービスを運営する第三者が定める各規約に従うものとします。
                </li>
                <li css={li}>
                  パートナーサービス利用契約者は、自己の責任において、パートナーサービスアカウントを維持及び管理するものとします。
                </li>
                <li css={li}>
                  パートナーサービス利用契約者及び当該パートナーサービス利用契約者が招待したユーザーは、パートナーサービス利用契約者がその理由を問わずパートナーサービスに正常にログインできない状態となった場合には、当該ログインができない期間中、Mikatano
                  IDサービス等にもログインできず、Mikatano
                  IDサービス等を利用できないことを予め了承します。
                </li>
                <li css={li}>
                  パートナーサービスアカウントの管理不十分、使用上の過誤又は第三者の使用等による損害の責任はパートナーサービス利用契約者が負うものとし、当社は一切の責任を負いません。また、パートナーサービス利用契約者は当社に損害を与えた時は、その損害を賠償する責任を負います。なお、当社がパートナーサービスアカウントの第三者の使用等又はその合理的な疑いを検知した場合、当社はパートナーサービスを運営する第三者に対して通知し、パートナーサービスアカウントの使用停止を含む措置を図るよう当該第三者に対して求めることができます。
                </li>
                <li css={li}>
                  パートナーサービス利用契約者は、自己の責任においてパートナーサービスを利用するものとし、パートナーサービスを利用したことにより生じた損害及びトラブル等について当社は責任を負いません。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第9条の2（当社の他サービスの利用）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、プランの一部として、当社が提供する指定サービス以外のサービス（以下「当社他サービス」といいます。）を含める場合があります。
                </li>
                <li css={li}>
                  利用者は、当社他サービスを利用する場合、当社が当社他サービスにおいて定める利用規約その他の条件（当該利用規約その他の条件が変更された場合は変更後の条件も含みます。）等に基づき当社他サービスの利用登録を行うものとします。
                </li>
                <li css={li}>
                  利用者による当社他サービスの利用については、前項の利用規約その他の条件が適用され、別途の定めがある場合を除き、本規約及び指定サービス利用規約等は適用されません。
                </li>
                <li css={li}>
                  利用者は、サービス利用契約が終了した場合、プランに含まれる当社他サービスも利用できなくなる場合があることを、予め承諾するものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第10条（利用料金）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者は、第11条に規定する支払方法により、契約プランの利用料金を支払うものとします。利用料金の詳細は当社ウェブサイト等をご確認ください。なお、利用者が当社他サービス又は提携サービスを利用する場合、別途、当社他サービス又は提携サービスの利用の対価が発生する場合があります。当社他サービス及び提携サービスの利用の対価等については、当該サービスにおいて当社が定め、又は提携サービスを提供する第三者が定める利用規約その他の条件（当該利用規約その他の条件が変更された場合は変更後の条件も含みます。）等に従うものとします。
                </li>
                <li css={li}>
                  当社は、当社が必要と判断した場合、利用料金の改定を行うことができるものとします。ただし、利用料金の増額の場合、当社は料金を変更する旨及び変更後の料金並びに変更後の料金が適用される時期を当社ウェブサイト等への掲載その他当社が適当と判断する方法により、当該変更の相当期間前までに、契約者に通知します。また、当社は、当社の裁量で、既存の契約者に対し、旧利用料金の適用を認める移行期間を設けることができるものとします。
                </li>
                <li css={li}>
                  契約者が利用料金の支払を遅滞した場合、契約者は、当社に対し、年14.6％の割合による遅延損害金を支払うものとします。
                </li>
                <li css={li}>
                  契約者は、サービス利用契約を締結及び解約した日時に関わらず、契約者は第1項に定める利用料金を支払うものとし、日割計算等による精算及び返金は行いません。
                </li>
                <li css={li}>
                  契約者は、サービス利用契約及び契約プランを中途解約することはできないものとします。
                </li>
                <li css={li}>
                  サービス利用契約は、当社が別途定める場合を除き、契約者が有効期間終了日までに所定の利用終了手続を行わない限り、同一の契約プランにより自動的に更新されるものとします。
                </li>
                <li css={li}>
                  契約者が有効期間終了日前に当社の定める所定の方法により、Mikatano
                  IDサービスの利用終了手続を行った場合には、Mikatano
                  IDサービス及び契約プランに含まれるすべての指定サービスを利用できなくなるものとします。この場合において、当社が契約者から当社に対して支払われた利用料金の返金には一切応じないことにつき、契約者は予め承諾するものとします。
                </li>
                <li css={li}>
                  契約者は、契約プランに含まれる指定サービスの全部又は一部の利用開始手続を行っていないこと及び事業者登録削除手続を行ったことをもって、契約プランの料金の全部または一部の支払いを免れることはできないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第11条（支払方法）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  契約者は、当社が定める方法により、利用料金を支払うものとします。
                </li>
                <li css={li}>
                  当社が定める方法のうち、クレジットカード（契約者が自己名義又は当社が適当と認める名義のクレジットカードに限るものとします。以下同じです。）によって利用料金を支払う場合、契約者は、クレジット会社（以下「カード会社」といいます。）が定める支払期日までに利用料金を引落口座に振り込む方法によって支払うものとします。なお、カード会社から契約者への支払請求日は、カード会社の規約において定められるものとし、当社は一切関与しないものとします。また、カード会社の与信非承認、支払拒否、支払留保、倒産その他の理由の如何を問わず、契約者が利用料金の支払いを遅滞した場合、契約者は年14.6％の割合による遅延損害金を当社に支払うものとします。遅延損害金の支払方法は当社の指定する方法によるものとし、支払いにかかる手数料その他の費用は契約者の負担とします。
                </li>
                <li css={li}>
                  当社が定める方法のうち、クレジットカードによって利用料金を支払う場合、契約者は、登録したクレジットカードの情報（カード会社、カード番号等をいいます。以下同じです。）に変更があった場合には、当社所定の方法により、当該情報を変更し、利用料金の支払いが遅滞なく行われるようにしなければなりません。当該変更を怠ったことにより生じた損害については、当社は一切責任を負わないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第12条（サービス継続性保証）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、契約者（但し、有料の契約プランを利用している契約者に限ります。以下、本条において同じです。）に対し、当該有料の契約プランに含まれる指定サービスそれぞれの稼働時間を99.5%以上維持することを保証します。なお、当社は、提携サービスの継続性については保証せず、また、当社他サービスの継続性については当社が定める当社他サービスの利用規約その他の条件（当該利用規約その他の条件が変更された場合は変更後の条件も含みます。）等に従うものとします。
                </li>
                <li css={li}>
                  契約者は、指定サービスの１ヶ月間（当月の１日から末日までをいうものとし、直前30日をいうものではありません。以下、本条において同じです。）の「使用不能時間」が、3.6時間（１ヶ月の時間の0.5％に相当する時間です。）を超えた場合、当社に対し、自らの「使用不能時間」を申請できるものとし、当該申請された使用不能時間が適正であると当社が認めた場合（申請された使用不能時間の一部が適正であると認められ、認められた１ヶ月間の使用不能時間が3.6時間を超えた場合を含みます。）、当社は、以下に定める割合で算出した額を、申請日の属する日の翌々月分の利用料金から減額するものとします。申請を認められた契約者が申請日の属する月又は翌月に所定の有料指定サービスの利用終了手続を行った場合その他翌々月の利用料金が発生しない場合、当社は、当該契約者に対し、下記方法で算出した減額相当額を当社の定める方法で返金するものとします。
                  <br />
                  〔減額の割合〕
                  <br />
                  <ol css={ol}>
                    <li>
                      １ヶ月間における使用不能時間が3.6時間を超え、7.2時間以下の場合
                      <br />
                      本規約の別表に定める指定サービスごとの基準金額の20％
                    </li>
                    <li>
                      １ヶ月間における使用不能時間が7.2時間を超える場合
                      <br />
                      本規約の別表に定める指定サービスごとの基準金額の40％
                    </li>
                  </ol>
                </li>
                <li css={li}>
                  前項の「使用不能時間」とは、指定サービスの全契約者の5%を超える人数が、次の各号のいずれかに継続して該当する時間をいいます。なお、有料の契約プランに2以上の指定サービスが含まれる場合でも、使用不能時間は個別に算出し、合算しないものとします。
                  <ol css={ol}>
                    <li>
                      当該指定サービス利用にかかる当社ウェブサイト等をすべて表示できない時間
                    </li>
                    <li>
                      当該指定サービスにログインできない時間（ただし、アカウント連携を利用して当該指定サービスにログインする契約者が、パートナーサービスに正常にログインできないことにより当該指定サービスにログインできない時間は除きます。）
                    </li>
                    <li>
                      当該指定サービスによるすべての情報を閲覧することができない時間
                    </li>
                  </ol>
                </li>
                <li css={li}>
                  前項各号に該当する状態が生じていた場合でも、次の各号に該当する場合は、「使用不能時間」にあたらないものとします。
                  <ol css={ol}>
                    <li>午後10時から午前6時（日本時間）までの間に生じた場合</li>
                    <li>10分以上継続しなかった場合</li>
                    <li>
                      利用者の当該指定サービスの利用環境に起因又は関連して生じた場合
                    </li>
                    <li>
                      システムアップデートによる生じた場合（但し、当社が当該アップデート開始の5日以上前に当社ウェブサイト等により告知した時間帯において生じた場合に限る。）
                    </li>
                    <li>
                      本規約又は指定サービス利用規約等に基づき当該指定サービスを中断又は停止することにより生じた場合
                    </li>
                  </ol>
                </li>
                <li css={li}>
                  契約者が第2項の申請を行うことができるのは、契約者の１ヶ月間における「使用不能時間」が3.6時間を超えた月の翌月末日までとし、それ以後に申請があったときは、当社は第2項に定める義務を負わないものとします。第1項に定める継続保証に係る救済は、第2項に定めるものを唯一のものとします。
                </li>
                <li css={li}>
                  当社が指定サービスのサービス継続性保証に関し、指定サービス利用規約で別に定めた場合には、当該指定サービスについて本条では適用されないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第13条（利用者の禁止事項）</h4>
            <p css={p}>
              利用者は、Mikatano
              IDサービス等を利用するにあたり次の各号の行為又は次の各号に該当するおそれがあると当社が判断する行為を行わないものとします。
            </p>
            <ol css={ol}>
              <li>
                法令に違反する行為、法令違反を助長する行為又はそれらのおそれのある行為
              </li>
              <li>当社、他の利用者又は第三者に対する詐欺又は脅迫行為</li>
              <li>公序良俗に反する行為</li>
              <li>
                当社、他の利用者又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為
              </li>
              <li>
                Mikatano
                IDサービス等を通じ、以下に該当し、又は該当すると当社が判断する情報を送信する行為
                <br />
                ア 過度に暴力的又は残虐な表現を含む情報
                <br />
                イ コンピューター・ウィルスその他の有害なプログラムを含む情報
                <br />
                ウ
                当社他の利用者又は第三者の名誉又は信用を毀損する表現を含む情報
                <br />
                エ 過度にわいせつな表現を含む情報
                <br />
                オ 差別を助長する表現を含む情報
                <br />
                カ 自殺、自傷行為を助長する表現を含む情報
                <br />
                キ 薬物の不適切な利用を助長する表現を含む情報
                <br />
                ク 反社会的な表現を含む情報
                <br />
                ケ 他人に不快感を与える表現を含む情報
                <br />
                コ 虚偽の内容を含む情報
                <br />サ 宣伝、広告、勧誘、又は営業行為を含む情報
              </li>

              <li>
                Mikatano
                IDサービス等を通じてアクセスするコンテンツサイト及びAPI提供元のネットワーク又はシステム等に過度な負荷をかける行為
              </li>
              <li>他の利用者の情報の収集を目的とする行為</li>
              <li>
                Mikatano
                IDサービス等に接続しているシステム全般について、権限なく不正にアクセスする行為、当社の設備に蓄積された情報を不正に書換え若しくは消去する行為、その他当社に損害を与える行為
              </li>
              <li>他の利用者又は第三者になりすます行為</li>
              <li>
                他の利用者のユーザーアカウント又はパートナーサービスアカウントを利用する行為（複数人が１つのユーザーアカウントを共同利用する行為も含まれますが、これに限りません。）
              </li>
              <li>
                当社、他の利用者又は第三者に損害を加える目的をもって、ユーザーを招待すること
              </li>
              <li>反社会的勢力等への利益供与行為</li>
              <li>
                暴力又は脅迫的な言動（自己又は関係者が反社会的勢力等である旨を伝える行為も含まれますが、これに限りません。）を用いる行為
              </li>
              <li>
                当社によるMikatano IDサービス等の運営を妨害するおそれのある行為
              </li>
              <li>
                本規約又は指定サービス利用規約等及びMikatano
                IDサービス又は指定サービスの趣旨又は目的に反する行為
              </li>
              <li>前各号の行為を直接又は間接に惹起し、又は容易にする行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
            <h4 css={articleTitle}>第14条（バックアップ）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、Mikatano
                  IDサービス等に関して、利用者の登録情報、口座情報及び送信データ（以下「利用者データ」といいます。）を任意にバックアップいたしますが、バックアップの義務を負うものではありません。利用者は、利用者データを自己の責任において、管理又は保全しなければなりません。
                </li>
                <li css={li}>
                  利用者は、利用者データについて、利用者自身で適宜バックアップを取るなどの手法で保全しなければならず、当社は、利用者データの保全等について一切保証しないものとします。当社が予期し得ない不測の事態が発生したことにより利用者データが消失した場合、当社は一切の責任を負いません。
                </li>
                <li css={li}>
                  当社は、利用者データのバックアップデータが存在しないこと、利用者が利用者データのバックアップを適切に実施しなかったこと、その他バックアップデータの不存在に関して生じた利用者の損害及び不利益について、一切の責任を負いません。
                </li>
                <li css={li}>
                  当社は、Mikatano
                  IDサービス等の保守や改良などの必要が生じた場合、利用者データを当該保守や改良などに必要な範囲で複製等することができ、利用者は異議等を述べないものとします。
                </li>
                <li css={li}>
                  当社が、指定サービスにおける利用者データのバックアップに関し、指定サービス利用規約で別に定めた場合には、当該指定サービスについて本条では適用されないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>
              第15条（サービス利用停止又はユーザーアカウント削除）
            </h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、利用者が次の各号のいずれかに該当すること、又は該当するおそれがあると当社が判断した場合、事前の通知又は催告することなく、当該利用者のMikatano
                  IDサービス等の利用を一時的に停止その他の必要な措置をし、利用者としての登録を抹消、又は契約者との間のサービス利用契約の全部又は一部を解除することができるものとします。なお、当社が、本項に基づき、契約者の利用者としての登録を抹消した場合、又は契約者との間のサービス利用契約の全部又は一部を解除した場合、当社は、当該契約者が招待したユーザーについても利用者としての登録を抹消することができるものとします。
                  <ol css={ol}>
                    <li>
                      本規約、指定サービス利用規約等のいずれかの条項に違反した場合
                    </li>
                    <li>
                      本規約、指定サービス利用規約等に定める指定サービスの利用条件を満たさない場合
                    </li>
                    <li>
                      当社に提供された情報の全部又は一部に虚偽の事実があることが判明した場合
                    </li>
                    <li>
                      ユーザーアカウント又はパートナーサービスアカウントが第三者に盗用又は使用されている場合
                    </li>
                    <li>
                      当社が特別に認める場合を除いて契約プランを選択していない場合
                    </li>
                    <li>契約者が契約プランの利用料金を支払わない場合</li>
                    <li>
                      未成年者、成年被後見人、被保佐人又は被補助人のいずれかであって、法定代理人、後見人、保佐人又は補助人の同意等を得ていないことが判明した場合
                    </li>
                    <li>
                      契約者が支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合
                    </li>
                    <li>
                      契約者の信用力の著しい低下又は信用力に影響を及ぼす営業上の重要な変更がなされた場合
                    </li>
                    <li>
                      契約者が解散を決議し又は他の会社との合併等の会社再編を決議した場合
                    </li>
                    <li>利用者が死亡した場合</li>
                    <li>
                      当社からの問い合わせその他の回答を求める連絡に対して30日間以上応答がない場合
                    </li>
                    <li>
                      反社会的勢力等である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合、又は反社会的勢力等が経営に実質的に関与している法人等であると判明した場合
                    </li>
                    <li>
                      過去にMikatano
                      IDサービス等又は当社他サービスの利用停止、ユーザーアカウント削除等の措置を受け又は現在受けている場合
                    </li>
                    <li>
                      Mikatano IDサービス等の運営又は保守管理上必要である場合
                    </li>
                    <li>その他前各号に類する合理的な事由がある場合</li>
                  </ol>
                </li>
                <li css={li}>
                  前項各号のいずれかの事由に該当した場合、利用者は、当社に対して負っている債務の一切（本規約上の債務のみならず、利用者の当社に対する損害賠償債務も含みますが、これらに限りません。）について当然に期限の利益を失い、直ちに当社に対して全ての債務を履行しなければなりません。
                </li>
                <li css={li}>
                  利用者は、第1項に基づく措置がなされた後も、当社及びその他の第三者に対するMikatano
                  IDサービス等の利用に関する一切の義務及び債務（損害賠償債務を含みますが、これに限りません。）を免れるものではありません。
                </li>
                <li css={li}>
                  当社は、本条に基づき当社が行った行為により利用者に生じた損害について、当社に故意又は重過失があった時を除き、その責任を負わず、第1項に基づく措置がなされた後も、利用者データを保有及び利用することができるものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第16条（Mikatano IDサービス等の変更等）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、利用者に事前の通知をすることなく、Mikatano
                  IDサービス等及びMikatano
                  IDサービス等に関するソフトウェアの内容の全部又は一部を変更、追加、廃止することができるものとします。
                </li>
                <li css={li}>
                  当社は、当社の判断によりMikatano
                  IDサービス等の全部若しくは一部の提供又は運営を中止することができるものとします。また、当社は、当社の判断によりMikatano
                  IDサービス等の全部若しくは一部の提供又は運営を中止する場合、当社が適当と判断する方法で利用者にその旨通知します。ただし、緊急の場合は利用者への通知を行わない場合があります。
                </li>
                <li css={li}>
                  当社は、次の各号のいずれかの事由が生じた場合には、利用者に事前に通知することなく、Mikatano
                  IDサービス等の全部又は一部を一時的に中断することができるものとします。
                  <ol css={ol}>
                    <li>
                      Mikatano
                      IDサービス等の提供に用いるハードウェア、ソフトウェア又は通信機器設備等に関わるメンテナンスや修理を定期的又は緊急に行う場合
                    </li>
                    <li>電気通信事業者の役務が提供されない場合</li>
                    <li>
                      天災等の不可抗力によりMikatano
                      IDサービス等の提供が困難な場合
                    </li>
                    <li>
                      火災、停電、その他の不慮の事故、戦争、紛争、動乱、暴動又は労働争議等によりMikatano
                      IDサービス等の提供が困難な場合
                    </li>
                    <li>
                      アクセス過多、その他予期せぬ要因でシステムに負荷が集中した場合
                    </li>
                    <li>利用者のセキュリティを確保する必要が生じた場合</li>
                    <li>
                      コンテンツサイト、API提供元のシステム又は提携サービスの全部又は一部の提供が一時的に停止又は中断された場合
                    </li>
                    <li>
                      法令又はこれらに基づく措置によりMikatano
                      IDサービス等の運営が不能となった場合
                    </li>
                    <li>その他前各号に準じ当社が必要と判断した場合</li>
                  </ol>
                </li>
                <li css={li}>
                  利用者は、次の各号のいずれかに該当する場合、Mikatano
                  IDサービス等の利用の全部若しくは一部が制限されることがあることに予め承諾します。
                  <ol css={ol}>
                    <li>
                      Mikatano
                      IDサービス等の利用資格等の確認を目的としたユーザーアカウント等の認証機能において、利用資格等の確認ができない場合
                    </li>
                    <li>
                      インターネットに接続できない環境において、Mikatano
                      IDサービス等を利用する場合
                    </li>
                    <li>
                      リアルタイム通信ができない通信状況においてMikatano
                      IDサービス等を利用する場合
                    </li>
                  </ol>
                </li>
                <li css={li}>
                  当社は、利用者に対し、Mikatano
                  IDサービス等に関するソフトウェアのサポート及び修正版（アップデート版を含みます。）を提供する義務を負いません。
                </li>
                <li css={li}>
                  当社は、本条に基づき当社が行った措置により利用者に生じた損害について、当社に故意又は重過失があった時を除き、その責任を負いません。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第17条（権利の帰属）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社がMikatano
                  IDサービス等において提供する情報等に関する一切の知的財産権は、当社又は当社にライセンスを許諾している者に帰属します。
                </li>
                <li css={li}>
                  利用者は、当社の許諾を得ずに、当社が提供する情報等の翻訳、編集及び改変等を行い、又は第三者に使用させたり公開することはできず、いかなる理由によっても当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これらに限りません。）をしてはなりません。
                </li>
                <li css={li}>
                  Mikatano
                  IDサービス等において商標、ロゴ及びサービスマーク等（以下、総称して「商標等」といいます。）が表示される場合がありますが、当社は、利用者に対し当該商標等を譲渡し、又は使用を許諾するものではありません。
                </li>
                <li css={li}>
                  利用者は、当社に対し、利用者データをMikatano
                  IDサービス等に送信又は保存し、利用することについての適法な権利を有していること及び利用者データ及びその送信、保存又は利用が第三者の権利を侵害していないことについて、表明し、保証するものとします。
                </li>
                <li css={li}>
                  利用者は、当社に対し、利用者にMikatano
                  IDサービス等を提供するために必要な範囲、又は本規約及び指定サービス利用規約等に基づく場合に限り、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な利用者データの使用、複製、配布、派生著作物の作成、表示及び実行に関するライセンスを付与します。
                </li>
                <li css={li}>
                  利用者は、当社及び当社から権利を承継し又は許諾された者に対して著作者人格権を行使しないことに同意するものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第18条（送信データの取扱い）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、当社の裁量により送信データの内容を確認し、本規約若しくは指定サービス利用規約等に違反し又は違反する疑いがあると判断した場合には、利用者への事前の通知及び承諾なしに、送信データの全部又は一部を非表示に設定し、又は削除することができるものとします。当社は、送信データのMikatano
                  IDサービス等における表示の前後を問わず、当社が必要と判断した時に送信データの内容を確認できるものとします。
                </li>
                <li css={li}>
                  利用者は、送信データに知的財産権が含まれる場合、当該知的財産権（意匠権、著作権、商標権等を含みますがこれに限りません。）を自らが保有していること、自らが権利者より正当に使用を許諾されていること、又は適法に当該知的財産権を使用していることを保証するものとします。万一、第三者より送信データに対して異議が申し立てられた場合、当該異議に対しては利用者が自己の費用と責任をもって対処することとし、当社は一切の責任を負いません。当該異議に関連して当社に損害が生じた場合、利用者は当社に対しその損害を賠償するものとします。
                </li>
                <li css={li}>
                  利用者は、送信データ及びそのデータに起因する物理的、精神的被害を含む一切の結果に対して責任を持つものとします。
                </li>
                <li css={li}>
                  当社は、Mikatano IDサービス等において、Mikatano
                  IDサービス等の利用状況の把握、
                  それらの運用若しくは改善又は当社若しくは当社以外の第三者が提供する広告の最適化（当該広告効果測定を含みます。）の目的のため、
                  当社又は
                  <a
                    href="https://moneyforward-x.co.jp/external-tools/list/"
                    target="_blank"
                    css={a}
                  >
                    第三者が提供するツール
                  </a>
                  （以下「外部送信ツール」といいます。なお、外部送信ツールの利用に関する詳細については
                  <a
                    href="https://moneyforward-x.co.jp/external-tools/"
                    target="_blank"
                    css={a}
                  >
                    「外部送信ツールに関する公表事項」
                  </a>
                  をご確認ください。）を利用して、
                  利用者に関する情報（広告識別子その他ご利用の端末やアプリの情報、IPアドレス等のネットワークの情報やアクセス履歴等。
                  なお、アクセス履歴には、広告ページ及び当社のサービスとクッキー連携しているサイトでの行動履歴等のアクセスログを含みます。）を取得し、分析しています。
                  また、当社は当該目的のため、ツール提供元又は広告配信業者等の外部送信ツール提供者等から当該利用者に関する情報及び当該外部送信ツール提供者等による分析結果の情報等を取得する場合があります。
                  これらの情報が単体では個人を識別する情報を含まない場合には、個人情報に該当しませんが、当社は、これらの情報と利用者の個人情報を紐づける場合があり、この場合は、これらの情報も個人情報として取り扱います。
                  なお、外部送信ツール提供者等が収集した情報は外部送信ツール提供者等の個人情報保護方針（プライバシーポリシー）に基づき管理されています。
                  外部送信ツール提供者等の個人情報保護方針（プライバシーポリシー）及び無効設定（オプトアウト）の方法については、外部送信ツール提供者等のサイトをご覧ください。
                  当社は、外部送信ツール提供者等による当該情報の利用について責任を負わないものとします。
                </li>
                <li css={li}>
                  当社が許諾する第三者は、利用者に対して何ら告知することなく、前項に記載する行為を行うことができ、また当該行為について利用者に対しいかなる対価、報酬の支払いも必要としないものとします。利用者はこれらを予め異議無く承諾し、当社が許諾する第三者に対して当該行為に関する一切の責任を免除し、著作者人格権その他の権利を行使しないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第19条（非表示）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者データが第13条に規定する利用者の禁止事項に違反した場合又は違反するおそれがあると当社が合理的事由に基づき判断する場合、当社は、当該違反事由又は当該違反のおそれが解消したと判断できるようになるまで、当社の裁量により、当該利用者の承諾なしに、当該利用者データを一時的に非表示にすることができるものとし、利用者はこれに対して予め異議無く承諾するものとします。
                </li>
                <li css={li}>
                  前項の場合、当社は利用者に対する通知をもって、当社が指定する一定の期間内に利用者自身において第13条に違反する事由を除去すべき旨を告知するものとし、利用者は当該期間内にかかる告知に従い、第13条に違反する又は違反するおそれがある事由を解消し、又は当該違反を回避するために利用者データを改変若しくは削除するものとします。
                </li>
                <li css={li}>
                  当社は、前項の期間内に第13条に違反事由又は違反するおそれがある事由が解消したと判断できず、かつ利用者が当該利用者データを改変又は削除しない場合、利用者に通知したうえで、利用者データを第13条に違反しないと当社が判断しうるような結果になるように改変又は削除することができるものとし、利用者はこれに対して著作権、著作者人格権その他一切の権利を行使せず、かつ、異議を述べないものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第20条（登録情報の管理等）</h4>
            <p css={p}>
              利用者は登録情報を厳重に管理及び保管するものとします。利用者による登録情報の失念、消失及び登録情報の管理の不徹底による損害の責任は利用者が負うものとし、当社は一切の責任を負いません。また利用者は自己の登録情報が他者によって不正利用されていることを知った場合、直ちに当社にその旨を連絡し、当社の指示に従うものとします。
            </p>
            <h4 css={articleTitle}>第21条（情報の利用等）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、Mikatano
                  IDサービス等に関し取得する利用者に関する情報を、利用者の秘密情報として取扱い、法令で定められている範囲を超えて、また、次の各号に掲げる利用目的の範囲を超えて利用することはありません。
                  <ol css={ol}>
                    <li>利用者の同一性及び利用資格の確認のため</li>
                    <li>Mikatano IDサービス等を運営管理するため</li>
                    <li>利用料金、遅延損害金等の請求のため</li>
                    <li>
                      利用料金の決済等におけるクレジットカードの有効性の確認のため
                    </li>
                    <li>
                      利用者に合わせたMikatano
                      IDサービス等上の情報提供又は広告配信のため
                    </li>
                    <li>
                      Mikatano
                      IDサービス等及び当社又は当社グループ会社が提供するサービスに関する案内のため
                    </li>
                    <li>
                      Mikatano IDサービス等の停止、中止又は契約解除の通知のため
                    </li>
                    <li>
                      本規約又は指定サービス利用規約等に違反する行為への対応のため
                    </li>
                    <li>
                      本規約、指定サービス利用規約等又はMikatano
                      IDサービス等の利用に関するルール等の変更などの通知のため
                    </li>
                    <li>紛争、訴訟などへの対応のため</li>
                    <li>
                      Mikatano IDサービス等に関する問い合わせ等への対応のため
                    </li>
                    <li>
                      年代、所属、業種、規模その他の観点から分析することにより、個別の法人、団体及び個人を識別することのできない形式に加工したデータ及び統計データ（以下「統計データ等」といいます。）を作成し、Mikatano
                      IDサービス等及びその他の当社の提供するサービスの向上及び改善、サービス開発、研究、市場分析、マーケティングを行うため
                    </li>
                    <li>
                      前各号に付随するMikatano
                      IDサービス等の提供、維持、改善又は開発のため
                    </li>
                  </ol>
                </li>
                <li css={li}>
                  当社は、利用者の承諾がない限り、当該利用者の情報を第三者に開示又は共有することはありません。ただし、次の各号に掲げる場合は除きます
                  <ol css={ol}>
                    <li>
                      当社がMikatano
                      IDサービス等の利用状況を把握するために適切と判断するツールを利用する上で必要な範囲内において当該ツール提供元に利用者の情報を提供する場合
                    </li>
                    <li>
                      当社が利用目的の達成に必要な範囲内において利用者の情報の取扱いの全部又は一部を委託する場合
                    </li>
                    <li>
                      利用者に利用料金を請求する目的で、決済システム会社、クレジットカード会社及び銀行に利用者の情報を預託する場合
                    </li>
                    <li>
                      合併その他の事由による事業の承継に伴って利用者の情報が提供される場合
                    </li>
                    <li>法令に基づく場合</li>
                    <li>
                      法令諸規則に基づき裁判所、警察等の公的機関に開示を求められた場合
                    </li>
                    <li>統計データ等を第三者に提供する場合</li>
                  </ol>
                </li>
                <li css={li}>
                  当社は、利用者に関する情報の利用目的を、変更前の利用目的と相当の関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には第28条に従って、利用者に通知します。
                </li>
                <li css={li}>
                  当社は、Mikatano IDサービス等において、Mikatano
                  IDサービス等の利用状況の把握、Mikatano
                  IDサービス等の運用若しくは改善又は当社若しくは当社以外の第三者が提供する広告の最適化（当該広告効果測定を含みます。）の目的のため、
                  <a
                    href="https://moneyforward-x.co.jp/external-tools/list/"
                    target="_blank"
                    css={a}
                  >
                    当社が適切と判断するツール
                  </a>
                  を利用して、アクセスログ等の情報（閲覧したウェブページ、利用環境等の情報、広告ページ及び当社のサービスとクッキー連携しているサイトでの行動履歴等の情報をブラウザやアプリから自動的に受け取ったものを含みます。）を収集し、分析しています。また、当社は当該目的のため、ツール提供元又は広告配信業者等、当社以外の第三者からアクセスログ等の情報及び当該第三者による分析結果の情報等を取得する場合があります。これらの情報が単体では個人を識別する情報を含まない場合には、個人情報に該当しませんが、当社は、これらの情報と利用者の個人情報を紐づける場合があり、この場合は、これらの情報も個人情報として取り扱います。なお、各ツール提供元が収集した情報は各ツール提供元の個人情報保護方針に基づき管理しており、各ツール提供元の個人情報保護方針及びオプトアウトの方法については、各ツール提供元のサイトをご覧ください。当社は、各ツール提供元のサービス利用による損害について責任を負わないものとします。
                </li>
                <li css={li}>
                  当社は、第1項及び第2項にかかわらず、Mikatano
                  IDサービス等の利用を通じて取得した利用者の個人情報を当社が別途規定する
                  <a
                    href="https://moneyforward-x.co.jp/privacy/"
                    target="_blank"
                    css={a}
                  >
                    個人情報保護方針
                  </a>
                  （「個人情報の取扱について」を含みます。以下同じです。）及び指定サービスにおける利用者情報の第三者提供に関する特約に則って取り扱うものとし、利用者は、当社が利用者の個人情報を個人情報保護方針及び当該特約に従って取り扱うことに予め承諾するものとします。
                </li>
                <li css={li}>
                  当社は、利用者データに含まれる利用者以外の者の個人情報を取り扱いません。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第22条（損害賠償）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者は、本規約又は指定サービス利用規約等に違反することにより、又はMikatano
                  IDサービス等の利用に関連して当社に損害を与えた場合、当社に対しその全ての損害（弁護士等専門家費用及び当社人件費相当額を含みます。）を賠償しなければなりません。
                </li>
                <li css={li}>
                  当社が利用者によるMikatano
                  IDサービス等の利用に関連して他の利用者又は第三者から権利侵害その他の理由により何らかの請求を受けた場合、利用者は、当該請求に基づき当社が当該第三者に支払いを余儀なくされた金額及び当該請求に係る紛争の解決のために当社が負担した金額（弁護士等専門家費用及び当社人件費相当額を含みます。）を賠償しなければなりません。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第23条（保証の否認及び免責）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、(1) Mikatano IDサービス等及びMikatano
                  IDサービス等を通じて提供されるコンテンツその他Mikatano
                  IDサービス等により利用者が取得し得る一切の情報が利用者の特定の目的に適合すること及び期待する機能、商品的価値、正確性又は有用性を有すること、(2)
                  利用者によるMikatano
                  IDサービス等の利用が利用者に適用のある法令又は業界団体の内部規則等に適合すること、(3)
                  Mikatano
                  IDサービス等に不具合が生じないこと及び当社が当該不具合を解消すること、(4)
                  Mikatano
                  IDサービス等を通じて提供されるコンテンツが適法に利用可能であること、並びに(5)
                  Mikatano
                  IDサービス等が第三者の権利を侵害しないこと等について、何ら保証するものではありません。
                </li>
                <li css={li}>
                  当社は、当社によるMikatano
                  IDサービス等の提供の中断、停止、終了、利用不能又は変更、利用者データの削除又は消失、利用者の登録の抹消、機器の故障若しくは損傷、その他Mikatano
                  IDサービス等に関して利用者が被った損害について、当社に故意又は重過失があった時を除き、賠償する責任を一切負わないものとします。
                </li>
                <li css={li}>
                  利用者と第三者との間で紛争が生じた場合には、利用者は自身の責任と費用でこれを解決するものとし、当社はこれに一切関与しません。
                </li>
                <li css={li}>
                  当社は、Mikatano
                  IDサービス等が全ての端末に対応していることを保証するものではなく、また、Mikatano
                  IDサービス等の利用開始時に特定の端末に対応していた場合でも、当該端末のOSのバージョンアップ等に伴いMikatano
                  IDサービス等の動作に不具合が生じる可能性があることについて、利用者は予め承諾するものとします。当社は、当社がプログラムの修正等により当該不具合を解消することを保証しません。
                </li>
                <li css={li}>
                  当社は、Mikatano
                  IDサービス等に関連して利用者が被った損害について、当社に故意又は重過失があった時を除き、一切賠償の責任を負いません。ただし、当社に故意又は重過失がある場合においても、当社の賠償責任の範囲は、当社の責に帰すべき事由により現実に発生した直接かつ通常の損害に限られるものとし、かつ、損害の事由が生じた時点から遡って過去１年間に契約者から現実に受領した利用料金の総額を上限とします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第24条（契約者の退会）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  契約者は、当社所定の方法によりMikatano
                  IDサービスを退会することができるものとします。Mikatano
                  IDサービスを退会した契約者及び当該契約者が招待したユーザーは、契約者の退会の時点からMikatano
                  IDサービス等のすべてを利用することができなくなるものとします。
                </li>
                <li css={li}>
                  契約者は、Mikatano
                  IDサービスの退会の時に当社に対して債務（本規約上及び指定サービス利用規約上の債務のみならず、契約者の当社に対する損害賠償債務も含みますが、これらに限られません。）を負っている場合、当社に対する債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務を履行しなければなりません。
                </li>
                <li css={li}>
                  利用者は、契約者のMikatano IDサービスの退会後も、Mikatano
                  IDサービス等の利用により利用者が当社に対して負った義務及び債務を免れるものではありません。
                </li>
                <li css={li}>
                  契約者は、Mikatano IDサービスの退会後、再度Mikatano
                  IDサービスの利用の登録を希望する際は、再度、登録手続を行う必要があります。契約者は再度の登録手続によっても、退会前の利用者データが復元又は引き継ぎされないことを予め承諾するものとします。
                </li>
                <li css={li}>
                  契約者は、Mikatano
                  IDサービスの退会後も利用者データを利用する場合、自己の責任において利用者データを保全し、当社は利用者データを引渡す義務を負わないものとし、利用者はこれを異議なく承諾するものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第25条（指定サービスの事業者登録の削除）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  契約者は、当社所定の方法によって指定サービスの事業者登録を削除することにより、契約プランに含まれる指定サービスの全部又は一部の利用を終了することができるものとします。なお、本項に基づく事業者登録の削除によって契約プランの変更の効力は発生しないものとし、契約者は、契約プランを変更する場合は第6条の規定に定める手続によるものとします。
                </li>
                <li css={li}>
                  当社は、契約プランの変更により変更後の契約プランに指定サービスが含まれなくなった場合及び本規約又は指定サービス利用規約等に基づいて指定サービスの提供を利用停止等する場合、契約者の当該指定サービスの事業者登録を削除します。
                </li>
                <li css={li}>
                  前二項に基づき契約者の指定サービスの事業者登録が削除された場合、契約者及び契約者が招待してユーザーは、当該指定サービスの事業者登録の削除の時から当該指定サービスを利用することができなくなるものとします。
                </li>
                <li css={li}>
                  指定サービスの事業者登録の削除後、契約者が再度当該指定サービスの利用を希望する際は、当社の定める方法により、再度、利用開始に関する手続を行う必要があります。この場合において、契約者は、再度の利用開始に関する手続によっても指定サービスの事業者登録削除前の利用者データが復元されないこと又は引き継がれないことを予め承諾するものとします。
                </li>
                <li css={li}>
                  当社は、事業者登録が削除された指定サービスに関する利用者データを引渡す義務を負わないものとし、利用者はこれを異議なく承諾するものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第26条（反社会的勢力の排除）</h4>
            <p css={p}>
              当社は、反社会的勢力等によるMikatano
              IDサービス等の利用を禁止します。当社は、利用者がこれらの者に該当すると判断した場合、事前に利用者に通知することなく、Mikatano
              IDサービス等の提供の停止又はサービス利用契約の解除をすることができるものとします。当社は、Mikatano
              IDサービス等の提供停止又はサービス利用契約の解除によって利用者に生じた損害や不利益について、一切の責任を負いません。
            </p>
            <h4 css={articleTitle}>第27条（サービス利用契約の有効期間）</h4>
            <p css={p}>
              サービス利用契約は、当該契約者がMikatano
              IDサービスを退会した日又は当該契約者のユーザーアカウントが削除された日のいずれか早い日までの間、当社と契約者との間で有効に存続するものとします。
            </p>
            <h4 css={articleTitle}>第28条（規約改定）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  当社は、次の各号のいずれかに該当する場合、利用者の承諾を得ることなく、本規約、指定サービス利用規約、指定サービスに関する特約及び利用者情報の第三者提供に関する特約を変更できるものとします。
                  <ol css={ol}>
                    <li>
                      変更内容がサービス名や表現の変更又は誤字、脱字の修正等であり、本規約又は指定サービス利用規約の内容に実質的に影響しない場合
                    </li>
                    <li>変更内容が利用者の一般の利益に適合する場合</li>
                    <li>
                      変更内容が契約した目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他変更に係る事情に照らして合理的なものである場合
                    </li>
                  </ol>
                </li>
                <li css={li}>
                  当社は、前項第2号及び前項第3号による変更の場合、本規約及び指定サービス利用規約等の変更の効力発生の相当期間前までに、本規約又は指定サービス利用規約等を変更する旨及び変更後の本規約又は指定サービス利用規約等の内容並びにその効力発生時期を当社ウェブサイト等への掲載その他当社が適当と判断する方法により通知します。なお、前項第1号による変更の場合、変更後の本規約又は指定サービス利用規約等の内容を当社ウェブサイト等への掲載その他当社が適当と判断する方法により通知した時点で変更後の本規約又は指定サービス利用規約等の効力が発生するものとします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第29条（連絡・通知）</h4>
            <p css={p}>
              Mikatano
              IDサービス等に関する問い合わせその他利用者又は利用希望者から当社に対する連絡又は通知及び本規約又は指定サービス利用規約等の変更に関する通知その他当社から利用者に対する連絡又は通知は、電子メールの送信又は当社ウェブサイト等への掲載を含む当社の定める方法で行うものとします。なお、当社が、利用者に対する連絡又は通知を電子メールの送信又は当社ウェブサイト等への掲載により行う場合、当該電子メールが当社から発信された時点又は当社ウェブサイト等に掲載された時点で、当該連絡又は通知が行われたものとみなします。
            </p>
            <h4 css={articleTitle}>第30条（本規約上の地位の譲渡等）</h4>
            <div css={article}>
              <ol>
                <li css={li}>
                  利用者は、当社の書面による事前の承諾なく、サービス利用契約上の地位又は権利義務の全部若しくは一部を、第三者に対して譲渡（本条において合併、会社分割等による包括承継を含みます。以下同じ。）し又は担保の目的に供することはできません。
                </li>
                <li css={li}>
                  当社がMikatano
                  IDサービス等の全部又は一部にかかる事業を第三者に譲渡した場合には、当該事業譲渡に伴いサービス利用契約上の地位及び権利義務並びに登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡できるものとし、利用者は、かかる譲渡につき予め同意したものとみなします。
                </li>
              </ol>
            </div>
            <h4 css={articleTitle}>第31条（分離可能性）</h4>
            <p css={p}>
              本規約又は指定サービス利用規約等のいずれかの条項若しくはその一部が、法令等により無効又は執行不能と判断された場合であっても、本規約又は指定サービス利用規約等の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及び利用者は、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。
            </p>
            <h4 css={articleTitle}>第32条（存続条項）</h4>
            <p css={p}>
              第14条（バックアップ）、第15条（サービス利用停止又はユーザーアカウント削除）第2項乃至第4項、第16条（Mikatano
              IDサービス等の変更等）乃至第26条（反社会的勢力の排除）及び第30条（本規約上の地位の譲渡等）乃至第33条（準拠法及び管轄）については、サービス利用契約が終了した場合でも、その終了原因の如何を問わず、なお効力を有するものとします。
            </p>
            <h4 css={articleTitle}>第33条（準拠法及び管轄）</h4>
            <p css={p}>
              サービス利用契約の準拠法は日本法とし、Mikatano
              IDサービス等に起因し又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
            <p css={p}>
              制定：2022年7月12日
              <br />
              最終改定：2026年1月21日
            </p>
          </p>
        </div>
      </div>
    </>
  );
};

const container = css({
  justifyContent: "center",
  textAlign: "left",
});

const box = css({
  boxSizing: "border-box",
  margin: "auto",
  alignItems: "flexStart",
  padding: "3px 0px 36px",
  width: "703px",
  border: "1px solid #DADEDF",
  borderRadius: "2px",
});

const spModeBox = css({
  boxSizing: "border-box",
  margin: "auto",
  alignItems: "flexStart",
  padding: "3px 0px 36px",
  border: "1px solid #DADEDF",
  borderRadius: "2px",
});

const content = css({
  margin: "0 auto",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "14px 24px 0px",
  gap: "10px",
});

const articleTitle = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "24px 0px 16px 24px",
  gap: "10px",
  width: "100%",
  height: "54px",
  fontWeight: "900",
});

const article = css({
  margin: "0 auto",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "14px 24px 0px 0px",

  fontFamily: "Hiragino Kaku Gothic Pro",
  fontStyle: "normal",
  fontWeight: "300",
  fontSize: "14px",
  lineHeight: "21px",
});

const li = css({
  marginBottom: "30px",
});

const ol = css`
  li {
    list-style-type: none;
    counter-increment: cnt;
    margin-left: 1.4em;
    text-indent: -3em;
    margin-bottom: 15px;
    padding-right: 24px;
  }
  li::before {
    content: "（" counter(cnt) "）";
  }
`;

const p = css({
  margin: "0 auto",
  padding: "14px 24px 0px",
});

const a = css({
  color: "#1A73E8",
});
